<script setup lang="ts">
const { metaTitle, pageTitle, pageDescription } = usePageTranslation()

useHead({
	title: metaTitle,
})
</script>

<template>
	<ui-sidebar-provider>
		<ui-sidebar collapsible="icon">
			<ui-sidebar-header class="border-b">
				<team-switcher />
			</ui-sidebar-header>
			<ui-sidebar-content>
				<primary-menu />
			</ui-sidebar-content>
			<ui-sidebar-footer class="border-t">
				<user-menu />
			</ui-sidebar-footer>
			<ui-sidebar-rail />
		</ui-sidebar>
		<ui-sidebar-inset>
			<header class="bg-sidebar flex shrink-0 items-center gap-2 border-b">
				<div class="flex items-center gap-2 px-4">
					<ui-sidebar-trigger class="-ml-1" />
				</div>
				<div class="py-4">
					<h1 class="text-2xl font-semibold">
						{{ pageTitle }}
					</h1>
					<p class="text-muted-foreground text-sm">
						{{ pageDescription }}
					</p>
				</div>
			</header>

			<slot />
		</ui-sidebar-inset>
	</ui-sidebar-provider>

	<ui-toast-toaster />
</template>
